import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const portfolioConfigSelector = ({ portfolioConfig }: ReducerState) => portfolioConfig;
export const portfolioConfigLoadingSelector = createSelector(
  portfolioConfigSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
